Ext.define('SA.CrosstabTableController', {
    extend: 'Ext.util.Observable',

    constructor({view, model, toolbar}) {
        var cellsCaches = {
            top: new SA.CrosstabHeaderCellsCache({top: true}),
            left: new SA.CrosstabHeaderCellsCache(),
            body: new SA.CrosstabBodyCellsCache()
        };

        this.view = view;
        this.model = model;
        this.toolbar = toolbar;

        this.table = new SA.SectionedTable({cellsCaches, parent: this.view.getTableTarget()});
        this.state = new SA.CrosstabState({location: this.model.getLocation(), maxSize: this.getMaxSize(), onChange: this.onStateChange.bind(this)});
        this.dragController = new SA.CrosstabDragController({table: this.table});

        this.initEvents();
    },

    destroy() {
        this.clearListeners();

        Ext.destroyMembers(this, 'table', 'state', 'dragController');

        this.view = null;
        this.model = null;
        this.toolbar = null;

        this.destroyed = true;

        this.callParent();
    },

    destroyCellMenu() {
        Ext.destroyMembers(this, 'cellMenu');
    },

    destroyTooltip() {
        Ext.destroyMembers(this, 'tooltip');
    },

    getMaxSize() {
        return this.view.getSize();
    },

    initEvents() {
        this.mon(this.view, 'resize', SA.createBuffered(this.onResize, 16), this); 
        this.mon(this.toolbar, 'change:mode', this.onChangeMode, this);

        this.table.on('userscroll', this.onScroll, this);
        this.table.on('cell:click', this.onCellClick, this);

        this.table.on('horizontalpercent:shouldshowtooltip', this.onHorizontalPercentShouldShowTooltip, this);
        this.table.on('index:shouldshowtooltip', this.onIndexShouldShowTooltip, this);
        this.table.on('verticalpercent:shouldshowtooltip', this.onVerticalPercentShouldShowTooltip, this);

        this.dragController.on('start', this.onDragStart, this);
        this.dragController.on('refresh', this.onDragRefresh, this);
        this.dragController.on('end', this.onDragEnd, this);
    },

    onCellClick(ev) {
        var {el, attribute} = ev.detail;

        if (this.state.isSelected(attribute)) {
            this.destroyCellMenu();
        }
        else {
            this.cellMenu = SA.CrosstabHeaderCellMenu.create({attribute, canRemoveAttribute: !this.state.isSingleAttributeInSide(attribute), target: el});
            this.cellMenu.on('destroy', this.onDestroyCellMenu, this);
            this.cellMenu.on('item:click', this.onClickCellMenuItem, this);

            this.state.setSelected(attribute);
        }
    },

    onChangeMode(isDefaultMode) {
        this.state.setIsDefaultMode(isDefaultMode);
    },

    onClickCellMenuItem(ev) {
        var attribute = this.state.getSelectedAttribute(),
            {type} = ev.detail.item;

        if (type === 'toggleFavorite') {
            SA.data.FavoriteAttributes.toggle(attribute);
        }
        else if (type === 'viewMetadata') {
            Ext.widget({xtype: 'metadata-window', autoShow: true, attribute});
        }
        else if (type === 'openDataFolder') {
            SA.Sidebar.openDataFolder(attribute);
        }
        else if (type === 'remove') {
            this.state.removeAttribute(attribute);

            this.model.setAttributesModel(this.state.cloneAttributes());
        }
    },

    onDestroyCellMenu() {
        this.state.clearSelected();
    },

    onDragEnd() {
        this.state.clearDrag();

        this.model.setAttributesModel(this.state.cloneAttributes());
    },

    onDragRefresh({position, scrollDelta}) {
        if (position.top || position.left) {
            this.state.dragTo(position);
        }
        else {
            this.state.revertDrag();
        }

        if (!Ext.Array.equals(scrollDelta, [0, 0])) {
            this.table.scrollBy(scrollDelta);

            this.refreshFrame();
        }
    },

    onDragStart({attribute}) {
        if (this.state.isSingleAttributeInSide(attribute)) {
            return false;
        }

        this.state.setIsDragging(attribute);
    },

    onHorizontalPercentShouldShowTooltip(ev) {
        var {el, state} = ev.detail;

        this.tooltip = SA.CrosstabHorizontalPercentTooltip.create({state, target: el});
    },

    onIndexShouldShowTooltip(ev) {
        var {el, state} = ev.detail;

        this.tooltip = SA.CrosstabIndexTooltip.create({state, target: el});
    },

    onResize() {
        this.state.setMaxSize(this.getMaxSize());
    },

    onScroll() {
        this.destroyCellMenu();
        this.destroyTooltip();

        this.refreshFrame();
    },

    onStateChange() {
        if (this.destroyed) {
            return;
        }

        this.view.removeLoadMask();

        this.refreshCellMenu();
        this.refreshSize();
        this.refreshFrame();
    },

    onVerticalPercentShouldShowTooltip(ev) {
        var {el, state} = ev.detail;

        this.tooltip = SA.CrosstabVerticalPercentTooltip.create({state, target: el});
    },

    refreshCellMenu() {
        if (!this.state.hasSelectedAttribute()) {
            this.destroyCellMenu();
        }
    },

    refreshFrame() {
        var {offset, data} = this.state.getFrame({rect: this.table.getScrollRect()});

        this.table.setFrameOffset(offset);
        this.table.setFrameData(data);
    },

    refreshSize() {
        this.table.setSizing(this.state.getSizing());
    },

    syncFromModel() {
        this.toolbar.refresh({
            location: this.model.getLocation(),
            datasetName: this.model.getDatasetName(),
            isDefaultMode: this.state.isDefaultMode()
        });

        this.state.setAttributes(this.model.cloneAttributes());
    }
});